export default __webpack_public_path__ + "static/media/Engineering.68eb7de3.png";